import { AuthProvider } from 'react-oidc-context';
import { WebStorageStateStore } from 'oidc-client-ts';

import LandingPage from '@App/pages/LandingPage/LandingPage';
import RiskDataPage from '@App/pages/RiskDataPage/RiskDataPage';
import CourseModules from '@App/pages/CourseModules/CourseModules';
import ExplorePage from '@App/pages/ExplorePage/ExplorePage';
import Admin from '@App/pages/Admin/Admin';
import AdaptationPage from '@App/pages/AdaptationPage/AdaptationPage';
import AllList from '@App/components/AdaptationListComponent/AllList/AllList';
import PlansList from '@App/components/AdaptationListComponent/PlansList/PlansList';
import StoriesList from '@App/components/AdaptationListComponent/StoriesList/StoriesList';
import CreatePlanForm from '@App/components/CreatePlanForm/CreatePlanForm';
import PlanDetail from '@App/components/PlanDetail/PlanDetail';
import StoryDetail from '@App/components/StoryDetail/StoryDetail';
import CreateStoryForm from '@App/components/CreateStoryForm/CreateStoryForm';
import CourseModuleSelector from '@App/components/CourseRelatedComponents/CourseModuleSelector/CourseModuleSelector';
import SessionSelector from '@App/components/CourseRelatedComponents/SessionSelector/SessionSelector';
import CourseContent from '@App/components/CourseRelatedComponents/CourseContent/CourseContent';
import CourseCompletion from '@App/components/CourseRelatedComponents/CourseCompletion/CourseCompletion';
import QuizComponent from '@App/components/QuizComponent/QuizComponent';

const routes = [
  {
    name: 'Landing',
    path: '/',
    element: <LandingPage />,
  },
  {
    name: 'Risk-data',
    path: '/risks',
    element: <RiskDataPage />,
  },
  {
    name: 'Course-module',
    path: '/learn',
    element: <CourseModules />,
    children: [
      {
        index: true,
        element: <CourseModuleSelector />,
      },
      {
        path: 'quiz',
        element: <QuizComponent />,
      },
      {
        path: 'module/:id',
        element: <SessionSelector />,
      },
      {
        path: 'module/:id/session/:id/part/:id',
        element: <CourseContent />,
      },
      {
        path: 'module/:id/completion',
        element: <CourseCompletion />,
      },
    ],  
  },
  {
    name: 'Explore',
    path: '/explore',
    element: <ExplorePage />,
  },
  {
    path: '/adaptation',
    element: <AdaptationPage />,
    children: [
      {
        index: true,
        element: <AllList />,
      },
      {
        path: 'plans',
        element: <PlansList />,
        children: [{
          path: ':id',
          element: <PlanDetail />,
        },
        {
          path: 'create',
          element: <CreatePlanForm />,
        },
        
        ],
      },
      {
        path: 'stories',
        element: <StoriesList />,
        children: [
          {
            path: ':id',
            element: <StoryDetail />,
          },
          {
            path: 'create',
            element: <CreateStoryForm />,
          },
        ],
      },
    ],
  },
  {
    name: 'Admin',
    path: '/admin/*',
    element: (
      <AuthProvider
        authority={`https://cognito-idp.eu-west-1.amazonaws.com/${import.meta.env.VITE_COGNITO_POOL_ID}`}
        client_id={import.meta.env.VITE_COGNITO_CLIENT_ID}
        redirect_uri={`${window.location.origin}/admin`}
        post_logout_redirect_uri={`${window.location.origin}/admin`}
        response_type="code"
        scope="email openid profile"
        onSigninCallback={() => window.history.replaceState({}, document.title, window.location.pathname)}
        automaticSilentRenew
        userStore={new WebStorageStateStore({ store: localStorage })}
      >
        <Admin />
      </AuthProvider>
    ),
  },
];

export default routes;